import { id } from 'date-fns/locale';
import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
export class RouteLineInput {
  aa: number;
  id: number;
  collectionOrderId: number;
  code: string;
  notes: string;
  statusId: number;
  isActive: boolean;

  constructor() {
    this.aa = undefined;
    this.id = undefined;
    this.collectionOrderId = undefined;
    this.code = undefined;
    this.notes = undefined;
    this.statusId = undefined;
    this.isActive = undefined;
  }
}
//FormInput needs to be updated like the form shape in the router-form-page.tsx
export class FormInput {
  id: number;
  code: string;
  routeDate: Date;
  vehicleId: number;
  driverId: number;
  notes: string;
  statusId?: number; // Optional if it is not required
  isActive?: boolean; // Optional if it is not required

  routesLines?: {
    aa?: number;
    id?: number;
    collectionOrderId?: number;
    isActive?: boolean;
    notes?: string;
    statusId?: number;
  }[];

  constructor() {
    this.id = undefined;
    this.code = undefined;
    this.routeDate = undefined;
    this.vehicleId = undefined;
    this.driverId = undefined;
    this.notes = undefined;
    this.statusId = undefined;
    this.isActive = undefined;
    this.routesLines = undefined;
  }
}

export const gqlGetCollectionOrdersByIds = gql`
  query fetchCollectionOrdersByIds($where: String) {
    getCollectionOrders(where: $where) {
      data {
        id
        code
        notes
        collectionPointId

        collectionpoint {
          name
          addressLine1
          addressArea
          addressCity
          addressDistrict
        }
      }
    }
  }
`;
export const gqlGetQuery = gql`
  query getRoutes($limit: Int, $offset: Int, $order: String, $where: String) {
    getRoutes(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        code
        seriesId
        codePrefix
        codeNumber
        routeDate
        dateCompleted
        vehicleId
        driverId
        notes
        statusId
        vehicle {
          id
          plateNumber
          collector {
            id
            name
          }
        }
        driver {
          id
          name
        }
        state {
          id
          name
        }
      }
      recordCount
    }
  }
`;
export const gqlGetByIdQuery = gql`
  query getRouteById($id: Int) {
    getRouteById(id: $id) {
      id
      code
      seriesId
      codePrefix
      codeNumber
      routeDate
      dateCompleted
      notes
      driverId
      vehicleId
      statusId
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      vehicle {
        id
        plateNumber
        collector {
          id
          name
          collectorsRegions {
            id
            regionId
            isActive
          }
          collectorsNomoi {
            id
            nomos
            isActive
          }
        }
      }
      driver {
        id
        name
      }
      state {
        id
        name
      }
      routesLines {
        id
        aa
        collectionOrderId
        statusId
        notes
        isActive
        state {
          id
          name
        }
        collectionOrder {
          id
          code
          collectionPointId
          notes
          collectionpoint {
            id
            name
            addressLine1
            addressLine2
            addressArea
            addressCity
            addressNomos
            addressDistrict
          }
        }
        collections {
          id
          code
        }
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addRoute($data: RouteInput) {
    addRoute(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateRoute($data: RouteInput) {
    updateRoute(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteRoute($id: Int) {
    deleteRoute(id: $id)
  }
`;
//create deleteRoutesLine function to delete a route line
export const gqlDeleteRoutesLine = gql`
  mutation deleteRoutesLine($id: Int) {
    deleteRoutesLine(id: $id)
  }
`;
export const qglReleaseRoute = gql`
  mutation completeRouteAndRelease($data: RouteInput) {
    completeRouteAndRelease(data: $data) {
      id
    }
  }
`;
